<template>
  <div>
    <v-container class="mt-3 resources-view" style="padding-top: 60px;max-width:1442px;position:relative">
      <v-layout row wrap v-if="pageData && pageData.resources">
        <v-flex xs12 class="mt-2">
          <p style="color:#4a4a4a;font-size:29px;font-weight:bolder;text-justify:auto;" class="page-header">
            {{ pageData.resources.header }}</p>
        </v-flex>

        <v-flex xs12 style="color:#4a4a4a;font-size:18px;font-weight:400;margin:0px;" class="page-subtitle">
          <div style="margin-top:-10px;padding-top:0px;">
            <p style="text-justify:auto;line-height:22px;">
              {{ pageData.resources.sub_text }}
            </p>
          </div>
        </v-flex>

      </v-layout>
      <v-layout>
        <v-flex xs9 md4 class="search_field">
          <i class="material-icons">
            search
          </i>
          <v-text-field name="input-3" v-model="search" placeholder="Type to search"></v-text-field>
        </v-flex>
        <v-flex xs3 hidden-md-and-up>
          <v-btn @click.prevent="viewMobileFilter = !viewMobileFilter" style="margin-top: 14px;text-transform:capitalize;" class="right">
            Filter
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row :wrap="breakpoint === 'xs' || breakpoint === 'sm'" id="resources-main-container">

        <v-flex xs12 md3 class="filter-sidebar-container hidden-sm-and-down">
          <v-card color="white px-3 py-4" class="filter_sidebar" :style="{width: width}">
            <h3 class="secondary--text">Content Type</h3>
            <h4 class="secondary--text" style="cursor:pointer;" @click.prevent="featuredResources(9)">All content</h4>
            <ul>
              <li v-for="(t, index) in contentType" :key="index">
                <a href="#" @click.prevent="filterPost('contenttype',t)">{{t}}</a>
              </li>
            </ul>
            <h3 class="secondary--text">Category</h3>
            <h4 class="secondary--text" style="cursor:pointer;" @click.prevent="featuredResources(9)">All categories</h4>
            <ul>
              <li v-for="(c, index) in category" :key="index">
                <a href="#" @click.prevent="filterPost('category',c)">{{c}}</a>
              </li>
            </ul>
            <h3 class="secondary--text">Date Posted</h3>
            <div class="date_range">
              <v-menu lazy :close-on-content-click="false" v-model="datepickermenufrom" transition="scale-transition" offset-y full-width
                :nudge-left="40" max-width="290px">
                <v-text-field slot="activator" required label="From" v-model="fromdate" readonly></v-text-field>
                <v-date-picker v-model="fromdate" no-title scrollable>
                  <template>
                    <v-card-actions>
                      <v-btn flat primary @click="datepickermenufrom = false">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
              <v-menu lazy :close-on-content-click="false" v-model="datepickermenuto" transition="scale-transition" offset-y full-width
                :nudge-left="40" max-width="290px">
                <v-text-field slot="activator" required label="To" v-model="todate" readonly></v-text-field>
                <v-date-picker v-model="todate" no-title scrollable>
                  <template>
                    <v-card-actions>
                      <v-btn flat primary @click="datepickermenuto = false">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </div>
            <v-btn class="date_btn" flat primary @click="save">Filter</v-btn>
          </v-card>
        </v-flex>
        <!-- <v-flex v-show="breakpoint === 'md' || breakpoint === 'lg' || breakpoint === 'xl'" :md3="breakpoint === 'md' || breakpoint === 'lg' || breakpoint === 'xl'"  class="ml-3 filter-sidebar-container">
        </v-flex> -->
        <mobile-resource-filter class="hidden-md-and-up" v-if="viewMobileFilter" hidden-md-and-up :filterPost="filterPost" :featuredResources="featuredResources" :contentType="contentType" :category="category" />
        <v-flex :xs12="breakpoint === 'xs'" :sm12="breakpoint === 'sm'" :md9="breakpoint === 'md'|| breakpoint === 'lg' || breakpoint === 'xl'" class="px-2">
          <v-layout row wrap>
            <v-flex :xs12="breakpoint === 'xs'" :xs6="breakpoint === 'sm'" :xs4="breakpoint === 'md' || breakpoint === 'lg' || breakpoint === 'xl'" px-2 py-2 v-for="(n, index) in sortedList" v-if="(index + 1) <= counter" :key="n.id" @click="viewResource(n)">
              <v-card class="resource_card">
                <div class="card_img">
                  <iframe v-if="n.media.id" :src="n.media.embedUrl" allowfullscreen style="width:100%;height:180px;border:none;"></iframe>
                  <img v-else :src="n.media" style="width:100%;height:180px;">
                </div>
                <div class="resource_content">
                  <span class="resource-title secondary--text">
                    {{n.title}}
                  </span>
                  <br>
                  <span class="resource-date">

                    {{n.revisiondate | actualDate}}
                  </span>
                  <div class="description" v-html="excerptDescs(n.content)"></div>
                </div>

              </v-card>
            </v-flex>
          </v-layout>
          <v-flex xs12 md12 class="load-data-div" style="text-align:center;">
            <button v-if="sortedList.length > counter" @click.prevent="counterPost(countlength)" class="btn btn--raised btn--round theme--dark primary load-more">Load More</button>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <resources-modal :dialog="dialog" :item="item" @cancel="cancel()" style="width:600px;" />
    <side-view-chat v-if="user.uid" />
    <!-- <site-footer></site-footer> -->
  </div>
</template>
<script>
import * as moment from "moment";
import Vue from "vue";
import uniq from "lodash/uniq";
import ResourcesModal from "@/components/modal/info/resourceViewModal.vue";
import SideViewChat from '@/components/chat/sideboxChat.vue'
import MobileResourceFilter from '@/components/mobile/ResourcesFilter.vue'

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(value).format("MMMM DD, YYYY");
  }
});
let db = Vue.prototype.$firebase.database();
Vue.filter("excerpt", function(value) {
  return value.substr(0, 36) + "...";
});
Vue.filter("json", function(value) {
  return json(value);
});
export default {
  data() {
    return {
      datepickermenu: false,
      datepickermenuto: false,
      datepickermenufrom: false,
      datefilter: null,
      fromdate: null,
      todate: null,
      dialog: false,
      item: null,
      counter: 9,
      viewMobileFilter: false,
      resources: [],
      width: '',
      sidebarScroll: () => {},
      search: '',
      filterContainerResize: null,
      category: [],
      filterType: '',
      filterValue: '',
      contentType: [],
      items: [],
      count: 0,
      countlength: 0
    };
  },
  components: {
    ResourcesModal,
    SideViewChat,
    MobileResourceFilter
  },
  firebase() {
    return {
      getResources: db.ref("resources")
    };
  },
  watch: {
    breakpoint () {

    }
  },
  computed: {
    breakpoint () {
      return this.$vuetify.breakpoint.name
    },
    pageData () {
      return this.$store.getters.getSettings.pages
    },
    user () {
      return this.$store.getters.getUserDetails
    },
    styles() {
      return this.$store.getters.getStyles;
    },
    htmlContent(data) {
      return data;
    },
    sortedList () {
      if (this.search.length) {
        var search = this.search.toLowerCase().split(' ')
        return this.resources.filter(resource => {
          return search.every((val => {
            if (resource.title.toLowerCase().indexOf(val) > -1 || resource.content.toLowerCase().indexOf(val) > -1) {
              return true
            } else {
              false
            }
          }))
        })
        .sort((d1, d2) => {
          return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime()
        })
      }
      return this.resources.sort((d1, d2) => {
        return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime()
      })
    }
  },
  mounted() {
    this.sticky()
    this.onResize()
    var id = window.location.hash.substring(1)
    if (id) {
      this.getResource(id)
    }
    const payload = {
      meta: {
        h1: this.pageData.resources.header,
        title: this.pageData.resources.header,
        description: "Resources Page",
        keywords: "",
        requiresAuth: true
      }
    };

    document.title = payload.meta.title;
    this.$store.commit("setHeaderInfo", payload);
    this.getCategory();
    this.getFeaturedResources();
  },
  methods: {
    sticky () {
      const self = this
      const sidebar = document.querySelector('.filter_sidebar.card')
      if (sidebar) {
        const sidebarPos = sidebar.getBoundingClientRect()
        const sidebarPosTop = sidebarPos.top < 550 ? 550 : sidebarPos.top
        const sidebarContainer = document.querySelector('.filter-sidebar-container')
        self.width = (sidebarContainer.clientWidth - 16) + 'px'
        const contentAreaHeight = document.getElementById('resources-main-container').offsetHeight
        window.addEventListener('scroll', () => {
          const windowScrollTop = document.documentElement.scrollTop
          if (windowScrollTop <= sidebarPosTop) {
            sidebar.className = sidebar.className.replace('sticky', '').trim()
          }
          // Scroll is past the original position of sidebar
          else if (windowScrollTop >= sidebarPosTop) {
              // Otherwise add the sticky if sidebar doesnt have it already!
              if (sidebar.className.indexOf('sticky') <= -1) {
                sidebar.className += ' sticky';
              }
          }
        })
      }
    },
    onResize () {
      const self = this
      const sidebarContainer = document.querySelector('.filter-sidebar-container')
      let watchResize = new window.WatchElementResize(sidebarContainer)
      watchResize.on('resize', event => {
        self.width = (event.element.offset.width - 16) + 'px'
      })
    },
    closeModal() {
      this.dialog = false;
    },
    cancel() {
      window.location.hash = ''
      this.dialog = false;
    },
    getCategory() {
      const self = this;
      self.category = [];
      self.contentType = [];
      self.countlength = 0;
      this.$firebase
        .database()
        .ref("resources")
        .on("value", snap => {
          snap.forEach(childSnapshot => {
            const childData = childSnapshot.val();
            self.countlength++;
            self.category.indexOf(childData["category"]) === -1
              ? self.category.push(childData["category"])
              : "";
            self.category = self.category.sort(function(a, b) {
              if (a < b) return 1;
              if (b < a) return -1;
              return 0;
            });
            self.contentType.indexOf(childData["contenttype"]) === -1
              ? self.contentType.push(childData["contenttype"])
              : "";
          });
        });
    },
    getFeaturedResources() {
      const self = this;
      this.$firebase
        .database()
        .ref("resources")
        .orderByChild("revisiondate")
        .on("value", snap => {
          self.items = [];

          snap.forEach(childSnapshot => {
            const childData = childSnapshot.val();

            if (!childData.featured) return

            self.getUserInfo(childData.uid, self.count).then(result => {
              self.items.push(childData);
            });
          });
          self.resources = self.items.sort(
            (d1, d2) =>
              new Date(d2.revisiondate).getTime() -
              new Date(d1.revisiondate).getTime()
          );
        });
    },
    save() {
      let self = this;
      self.items = [];
      self.resources = [];
      if (this.fromdate && this.todate) {
        this.$firebase
          .database()
          .ref("resources")
          .orderByChild("revisiondate")
          .startAt(Date.parse(this.fromdate))
          .endAt(Date.parse(this.todate))
          .on("value", snap => {
            self.items = [];
            self.resources = [];
            snap.forEach(childSnapshot => {
              const childData = childSnapshot.val();
              if (!childData.featured) return
              self.getUserInfo(childData.uid, self.count).then(result => {
                self.items.push(childData);
              });
            });
            self.counter = 9
            self.resources = self.items;
          });
      }
    },
    excerptDescs(v) {
      return v.substr(0, 80) + " ...";
    },

    viewEvent(val) {
      this.eventData = val;
      this.eventModal = true;
      this.selected = true;
    },
    eventClick(event, jsEvent, pos) {
      this.viewEvent(event);
    },
    openModal() {
      this.dialog = true;
    },
    closeViewEvent() {
      this.eventModal = false;
      this.selected = false;
    },
    viewResource(item) {
      window.location.hash = `#id=${item.id}`
      this.dialog = true;
      this.item = item;
    },
    counterPost(length) {
      this.counter = this.counter + 9;
    },
    filterPost(type, value) {
      let self = this;
      this.filterValue = value;
      this.filterType = type
      this.filteredResources(type, value);
    },
    filteredResources(col, filter) {
      let self = this;
      this.$firebase
        .database()
        .ref("resources")
        .orderByChild(col)
        .equalTo(filter)
        .on("value", snap => {
          self.items = [];
          self.resources = [];
          snap.forEach(childSnapshot => {
            const childData = childSnapshot.val();
            self.getUserInfo(childData.uid, self.count).then(result => {
              self.items.push(childData);
            });
          });
          self.counter = 9
          self.resources = self.items;
        });
    },
    featuredResources(counter) {
      let self = this;
      self.items = [];
      this.$firebase
        .database()
        .ref("resources")
        .orderByChild("revisiondate")
        .on("value", snap => {
          snap.forEach(childSnapshot => {
            const childData = childSnapshot.val();
            self.getUserInfo(childData.uid, self.count).then(result => {
              self.items.push(childData);
              self.counter = 9
              self.resources = self.items.sort(
                (d1, d2) =>
                  new Date(d2.revisiondate).getTime() -
                  new Date(d1.revisiondate).getTime()
              );
            });
          });
        });
    },
    getResource(id) {
      const self = this
      return this.$firebase.database().ref(`resources/${id.split('=')[1]}`).once('value', resourceSnap => {
        var resource = Object.assign({}, resourceSnap.val())
        return self.getUserInfo(resource.uid).then(userSnap => {
          resource.user = userSnap.val()
          return this.viewResource(resource)
        })
      })
    },
    getUserInfo(uid, index) {
      return this.$firebase
        .database()
        .ref("users/" + uid)
        .once("value");
    },

    getCompanyInformation(cid, index) {
      return this.$firebase
        .database()
        .ref("companies/" + cid)
        .once("value");
    }
  }
};
</script>
<style>
.filter_sidebar.card.sticky {
  position: fixed;
  top: 68px;
}
  .date_btn{
    margin:0;
  }
  .date_range .menu{
width: 40%;
    vertical-align: middle;
    display: block !important;
    margin-right: 20px;
    margin-left: 0px;
    float: left;
  }
  .card_img{
    width:100%;
    height:180px;
    text-align: center;
    background-size:cover;
    background-position:center center;
  }
  .card_img img{
    width: 100%;
    height:180px;
  }
.resource_card {
  min-height: 360px;
  cursor: pointer;
}
.resource_card .resource_content {
  padding: 10px 15px;
}
.resource_card .resource-title {
  font-size: 16px;
  line-height: 18px;
  color: #413127;
  font-weight: 600;
}
.resource_card .resource-date {
  font-size: 11px;
  color: #999;
}
.resource_card .description,
.resource_card .description > p > strong {
  font-size: 14px;
  line-height: 19px;
  color: #777;
  font-weight: 400 !important;
}
.search_field i {
  width: 25px;
  display: inline-block;
  vertical-align: middle;
}
.search_field .input-group {
  width: calc(100% - 70px);
  display: inline-block;
  vertical-align: middle;
}
.filter_sidebar h3 {
  font-size: 23px;
  font-weight: 600;
}
.filter_sidebar h4 {
  font-size: 16px;
}
.filter_sidebar ul {
  margin: 10px 0 30px;
  list-style: none;
  padding: 0;
}
.filter_sidebar ul li {
  margin: 10px 0;
}
.filter_sidebar ul li a {
  color: #888;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// ResourcesView.vue?41b818b8